export function hasPendingRubricEvidence(result) {
  return Boolean(result?.writingRubric?.pendingCriteria?.length)
    || Boolean(result?.methodSteps?.some(step => step.status === 'needs_evidence'));
}

export function reviewRubricCriterion(result, criterionIndex, value) {
  const step = result?.methodSteps?.[criterionIndex];
  if (!step || value === '' || value === null || !Number.isFinite(Number(value))) return result;
  const score = Number(value);
  if (score < 0 || score > Number(step.maxMarks)) return result;
  const steps = result.methodSteps.map((entry, index) => index !== criterionIndex ? entry : {
    ...entry, marksAwarded: score, status: score === Number(entry.maxMarks) ? 'awarded' : score > 0 ? 'partial' : 'not_awarded',
    teacherReviewed: true, feedback: 'Teacher reviewed this criterion.',
  });
  const criteria = (result.writingRubric?.criteria || []).map((entry, index) => index !== criterionIndex ? entry : {
    ...entry, score, evidence_status: 'teacher_reviewed', reason: 'Teacher reviewed this criterion.',
  });
  const pending = criteria.filter((entry, index) => steps[index]?.status === 'needs_evidence').map(entry => entry.id);
  const marksAwarded = steps.reduce((sum, entry) => sum + (Number(entry.marksAwarded) || 0), 0);
  const rubric = { ...result.writingRubric, criteria, pendingCriteria: pending, provisional: pending.length > 0, total_score: marksAwarded };
  for (const category of ['format', 'content', 'language']) {
    rubric[`${category}_score`] = steps.filter(entry => entry.category === category).reduce((sum, entry) => sum + (Number(entry.marksAwarded) || 0), 0);
  }
  rubric.deduction_reasons = steps.filter(entry => entry.status === 'needs_evidence' || Number(entry.marksAwarded) < Number(entry.maxMarks))
    .map(entry => `${entry.step}: ${entry.feedback}`);
  return { ...result, methodSteps: steps, marksAwarded, writingRubric: rubric, needsReview: true, autoChecked: false,
    reviewReason: pending.length ? 'Rubric evidence is unavailable or uncertain. Review each pending criterion before saving.' : 'Teacher edited rubric criteria: check before approving.',
    feedback: rubric.deduction_reasons.join('; '), criterionEvals: (result.criterionEvals || []).map((entry, index) => index !== criterionIndex ? entry : {
      ...entry, marks: score, assessmentStatus: 'teacher_reviewed', note: 'Teacher reviewed this criterion.',
    }) };
}
